export const dateTimeFormat = {
	timeZone: 'America/Chicago',
	locale: 'en-US',
};
